export default {
  data() {
    return {
      projectModel: {
        标签: [],
        对接hr: [],
      },
    }
  },
  created: function() {},
  methods: {
    async fetchProject(id) {
      if (!id) return
      this.projectModel = await window.app.service('project').fetch(id)
    },
    async updateProject({ id, param }) {
      if (!id) return
      await window.app.service('project').modify({ id, param })
      this.projectModel = Object.assign({}, this.projectModel, param)
    },
    removeProjectTag(_index, tag) {
      let index = _index
      if (index == null) {
        index = this.projectModel['标签'].findIndex(_tag => _tag === tag)
      }
      if (index > -1) this.projectModel['标签'].splice(index, 1)
    },
    addProjectTag(_tag) {
      const tag = _tag && _tag.trim()
      if (!tag) return
      if (!this.projectModel['标签']) this.projectModel['标签'] = []
      this.projectModel['标签'].push(tag)
    },
    dndProjectTag({ from, to }) {
      this.projectModel['标签'].splice(to.index, 0, from.tag)
      if (to.index < from.index) {
        this.projectModel['标签'].splice(from.index + 1, 1)
      } else {
        this.projectModel['标签'].splice(from.index, 1)
      }
    },
  },
}
